import SpotlightSection, { VisualFrame } from "@/components/wynn/SpotlightSection";

const AVATARS = [
  "linear-gradient(135deg,#FFB7C6,#E6BFFF)",
  "linear-gradient(135deg,#A8E6FF,#E6BFFF)",
  "linear-gradient(135deg,#E6BFFF,#FFB7C6)",
  "linear-gradient(135deg,#FFB7C6,#A8E6FF)",
  "linear-gradient(135deg,#A8E6FF,#FFB7C6)",
];

function CommunityVisual() {
  return (
    <VisualFrame
      gradient="linear-gradient(135deg, rgba(168,230,255,0.24) 0%, rgba(255,183,198,0.2) 55%, rgba(230,191,255,0.18) 100%)"
    >
      <div className="flex flex-col items-center">
        <div className="flex -space-x-3">
          {AVATARS.map((g, i) => (
            <span
              key={i}
              className="h-12 w-12 rounded-full border-2 border-[#0A0910]"
              style={{ background: g }}
            />
          ))}
        </div>
        <div className="mt-7 inline-flex items-center gap-2.5 border border-[#FFB7C6]/40 bg-[#070608]/40 px-3.5 py-2">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#FFB7C6] opacity-75" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-[#FFB7C6]" />
          </span>
          <span className="text-[10px] uppercase tracking-[0.24em] text-[#F4F1EC]/85 font-body">
            Live call · this Thursday
          </span>
        </div>
        <div className="mt-5 font-display text-[22px] italic font-light text-[#F4F1EC]">
          A small circle, gathering
        </div>
      </div>
    </VisualFrame>
  );
}

export default function CommunitySpotlight() {
  return (
    <SpotlightSection
      id="community"
      testId="wynn-community"
      labelColor="#A8E6FF"
      label="Community · in the full app"
      lead="A small circle,"
      accent="gathering live"
      body="An intentionally small community of artists on their own wellness path — and live calls inside the app you can simply drop into. Quiet, generous, real. App-only, opening with the full WYNN — a room to be a maker among makers."
      tags={["Live calls", "Intentionally small", "App-only"]}
      accentGradient="radial-gradient(50% 55% at 18% 25%, rgba(168,230,255,0.18) 0%, rgba(7,6,8,0) 60%), radial-gradient(50% 55% at 85% 80%, rgba(255,183,198,0.16) 0%, rgba(7,6,8,0) 65%)"
      visual={<CommunityVisual />}
    />
  );
}
